import { dev_environment } from "./constants";

const const_env = {

  REACT_APP_ENVIORNMENT: process.env.REACT_APP_ENVIORNMENT ?? dev_environment,

  DB_URL: process.env.REACT_APP_DB_URL ?? null,
  DB_URL_SUBSCRIPTION: process.env.REACT_APP_DB_URL_SUBSCRIPTION ?? null,
  ANONYMOUS_API_KEY: process.env.REACT_APP_ANONYMOUS_API_KEY ?? null,

  FIREBASE_API_CONFIG: process.env.REACT_APP_FIREBASE_API_CONFIG ?? '',
  FIREBASE_VAPID_KEY: process.env.REACT_APP_FIREBASE_VAPID_KEY ?? '',

  AWS_LAMBDA_AUTH_URL_TO_TABLET: process.env.REACT_APP_AWS_LAMBDA_AUTH_URL_TO_TABLET ?? null,
  AWS_LAMBDA_AUTH_URL_TO_MOBILE: process.env.REACT_APP_AWS_LAMBDA_AUTH_URL_TO_MOBILE ?? null,
  AUTH_LAMBDA_ENDPOINT: process.env.REACT_APP_AUTH_LAMBDA_ENDPOINT ?? null,
  REGISTRATION_GCP_ENDPOINT: process.env.REACT_APP_REGISTRATION_GCP_ENDPOINT ?? null,
  OTP_LAMBDA_AUTH: process.env.REACT_APP_OTP_LAMBDA_AUTH ?? null,
  OTP_LAMBDA_AUTH_EMAIL_VERIFY: process.env.REACT_APP_OTP_LAMBDA_AUTH_EMAIL_VERIFY ?? null,

  OPEN_AI_CHATBOT: process.env.REACT_APP_OPEN_AI_CHATBOT ?? '',

  LAUNCH_DARKLY_CLIENT_SECRET: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SECRET ?? null,

  CLOUDINARY_CLOUD_NAME: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME ?? '',

  ALGOLIA_APP_ID: process.env.REACT_APP_ALGOLIA_APP_ID ?? null,
  ALGOLIA_APP_KEY: process.env.REACT_APP_ALGOLIA_APP_KEY ?? null,
  ALGOLIA_INDEX_NAME: process.env.REACT_APP_ALGOLIA_INDEX_NAME ?? null,
  ALGOLIA_INGREDINETS_INDEX_NAME: process.env.REACT_APP_ALGOLIA_INGREDINETS_INDEX_NAME ?? null,

  SHOP_BASE_URL: process.env.REACT_APP_SHOP_BASE_URL ?? null,
  REGION: process.env.REACT_APP_BUCKET_REGION ?? '',
  HOMEPAGE_BUCKET_NAME: process.env.REACT_APP_HOMEPAGE_BUCKETNAME ?? '',
  ACCESS_KEY: process.env.REACT_APP_AWS_ACCESS_KEY ?? '',
  SECRET_ACCESS_KEY: process.env.REACT_APP_AWS_ACCESS_SECRET ?? '',
  DEFAULT_HOME_JSON: process.env.REACT_APP_DEFAULT_HOME_JSON ?? '',
  ANNOUNCEMENT_KEY: process.env.REACT_APP_ANNOUNCEMENT_KEY ?? '',
  SYNC_WS_URL: process.env.REACT_APP_SYNC_WS_URL ?? null,
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL ?? null,

  PUBLIC_POSTHOG_KEY: process.env.REACT_APP_PUBLIC_POSTHOG_KEY ?? '',
  PUBLIC_POSTHOG_HOST: process.env.REACT_APP_PUBLIC_POSTHOG_HOST ?? '',
  PING_BUCKETNAME: process.env.REACT_APP_PING_BUCKETNAME ?? '',
  PING_FILE_NAME: process.env.REACT_APP_PING_FILE_NAME ?? ''
};

export default const_env;
